import jwt_decode from 'jwt-decode'
import { privateAPI, utilUrl } from '../../config/constants'
import { decrypt, gettokenData } from '../../functions/globalFunctions'

let tokenData
if (localStorage.getItem('token')) {
  let token = jwt_decode(localStorage.getItem('token'))
  tokenData = decrypt(token.data)
}

export const getChampions = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-champions/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}
export const getNotToLossThem = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-not-to-loss-them/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getNew = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-new/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getAttention = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-attention/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getVendorSegmentation = () => {
  return async () => {
    //
    const res = await privateAPI.post(`${utilUrl}/get-vendor-segment/`, {
      data: { vendorId: gettokenData()?.vendorId },
    })
    if (res) {
      // let resp = decrypt(res.data)
      let resp = res.data
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getVendorCustomSegmentation = () => {
  return async () => {
    //
    const res = await privateAPI.post(`${utilUrl}/get-vendor-custom-segment/`, {
      data: { vendorId: gettokenData()?.vendorId },
    })
    if (res) {
      // let resp = decrypt(res.data)
      let resp = res.data
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getVendorSegmentationCriteria = () => {
  return async () => {
    //
    const res = await privateAPI.post(`${utilUrl}/get-vendor-segmentation-criteria/`, {
      data: { vendorId: gettokenData()?.vendorId },
    })
    if (res) {
      // let resp = decrypt(res.data)
      let resp = res.data
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getSegmentNumbers = (segment, synopsisDate) => {
  return async () => {
    //
    const res = await privateAPI.post(`${utilUrl}/get-vendor-segment-by-segmentname`, {
      data: { vendorId: gettokenData()?.vendorId, segment, synopsisDate },
    })
    if (res) {
      // let resp = decrypt(res.data)
      let resp = res.data
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getCustomSegmentNumbers = (segment, synopsisDate) => {
  return async () => {
    //
    const res = await privateAPI.post(`${utilUrl}/get-vendor-custom-segment-by-segmentname`, {
      data: { vendorId: gettokenData()?.vendorId, segment, synopsisDate },
    })
    if (res) {
      // let resp = decrypt(res.data)
      let resp = res.data
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getRisk = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-risk/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getLost = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-lost/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getStar = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-star/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      return resp
    }
  }
}

export const getBase = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-base/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      return resp
    }
  }
}

export const getLoyal = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-loyal/${tokenData?.vendorId}`, { year: 2022 })
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getVendorCampaignsSynopsis = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-vendor-campaigns/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getMonthlyReturningCustomers = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-monthly-returning-customers`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getCustomerResponseRate = () => {
  return async () => {
    const res = await privateAPI.post(`/synopsis/get-response-rate/${tokenData?.vendorId}`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getShopWiseData = (channel) => {
  return async () => {
    const res = await privateAPI.post(
      `/synopsis/get-shop-wise-campaign/${tokenData?.vendorId}/${channel}`,
    )
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getConversionRates = () => {
  return async () => {
    const res = await privateAPI.get(`/synopsis/get-conversion-rates`)
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}
